export const SourceSystemNames: { [key: string]: string } = {
  SalesCNP: "sales-cnp",
  ValueMyCar: "value-my-car",
  SalesOfficeCustomer: "sales-office-customer",
  Quotations: "quotations",
  SellMyCar: "sell",
  BranchAppraisal: "branch-appraisal",
  BranchJourney: "branch-journey",
  ValuationAdmin: "valuation-admin",
  SalesOffice: "sales-office"
};
